// extracted by mini-css-extract-plugin
export default {"deviceItemContainer":"DeviceItem_deviceItemContainer__T0Zz8","imageTypeContainer":"DeviceItem_imageTypeContainer__Rs5R3","deviceContents":"DeviceItem_deviceContents__jLwTw"};